import {all} from 'redux-saga/effects';

import appSaga from './appSaga';
import cardSaga from './cardSaga';
import bookSaga from './bookSaga';
import reviewSaga from './reviewSaga';
import socketSaga from './socketSaga';

export default function* sagas() {
	yield all([
		appSaga(),
		cardSaga(),
		bookSaga(),
		reviewSaga(),
		socketSaga(),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js